import { Constants, isPspAdministrator } from '@dx-ui/dx-common/src';
import { Button } from '@material-ui/core';
import {
  AutocompleteInput,
  Create,
  ReferenceInput,
  SaveButton,
  SimpleForm,
  Toolbar,
  required,
  useNotify,
  usePermissions,
  useRedirect,
  useTranslate,
} from 'react-admin';

export const SupportedProductsCreate: any = ({ setCreate, ...props }) => {
  const { permissions } = usePermissions();

  const notify = useNotify();

  const redirect = useRedirect();

  const onSuccess = () => {
    notify('resources.address.edit.notifications.created');
    if (setCreate !== undefined) {
      setCreate(false);
    } else {
      redirect('list', props.basePath);
    }
  };

  const onFailure = () => {
    notify('resources.supportedProducts.create.error', 'error');
  };

  const CustomCreateToolbar = (props) => (
    <Toolbar
      {...props}
      style={{ display: 'flex', justifyContent: 'space-between' }}
    >
      <SaveButton label='Save' />
      <CancelButton />
    </Toolbar>
  );

  const CancelButton = () => {
    const translate = useTranslate();
    return (
      <Button
        onClick={() => {
          if (setCreate !== undefined) {
            setCreate(false);
          } else {
            redirect('list', props.basePath);
          }
        }}
        variant='contained'
      >
        {translate('ra.action.cancel')}
      </Button>
    );
  };

  return (
    <Create
      {...props}
      onSuccess={onSuccess}
      onFailure={onFailure}
      resource={Constants.RESOURCE_SUPPORTED_PRODUCTS}
    >
      <SimpleForm toolbar={<CustomCreateToolbar />}>
        {isPspAdministrator(permissions) && (
          <ReferenceInput
            label='resources.accounts.create.wizard.steps.companySelection.company'
            source='idaccounts'
            reference='management/company'
            validate={required()}
            filterToQuery={(searchText) => ({
              accountname: [searchText],
            })}
            sort={{ field: 'accountname', order: 'ASC' }}
            defaultValue={parseInt(props?.id)}
            disabled={props.id}
          >
            <AutocompleteInput optionText='accountname' fullWidth />
          </ReferenceInput>
        )}
        <ReferenceInput
          label={'dxMessages.companyManagement.productUsage.product'}
          source='iddxproduct'
          reference='management/dxproduct'
          validate={required()}
          filterToQuery={(searchText) => ({
            description: [searchText],
          })}
          sort={{ field: 'description', order: 'ASC' }}
        >
          <AutocompleteInput optionText='description' />
        </ReferenceInput>
      </SimpleForm>
    </Create>
  );
};

export default SupportedProductsCreate;
